import React from 'react';
import { LINKS } from '../brand';
import './HowToUse.css';

const HowToUse = () => {
  const steps = [
    {
      number: '1',
      title: 'Téléchargez Shini Pay',
      description: (
        <>
          Installez l’app depuis l’
          <a href={LINKS.ios} target="_blank" rel="noopener noreferrer">App Store</a>
          {' '}ou le{' '}
          <a href={LINKS.android} target="_blank" rel="noopener noreferrer">Google Play Store</a>.
        </>
      ),
    },
    {
      number: '2',
      title: 'Connectez-vous',
      description: 'Ouvrez votre compte avec votre téléphone ou votre e-mail, puis le mot de passe. La biométrie est optionnelle.',
    },
    {
      number: '3',
      title: 'Rechargez',
      description: 'Ajoutez du solde avec Orange Money, Sama Money, Stripe ou un code de recharge.',
    },
    {
      number: '4',
      title: 'Utilisez la carte',
      description: 'Gérez vos cartes dans l’app, ajoutez-les à Apple Wallet, ou ouvrez le portail « Gérer ma carte ».',
    },
  ];

  return (
    <section id="how-to-use" className="how-to-use">
      <div className="container">
        <h2 className="section-title">Comment ça marche</h2>
        <p className="section-subtitle">
          Quatre étapes pour recharger et présenter votre carte cantine.
        </p>
        <ol className="steps-container">
          {steps.map((step) => (
            <li key={step.number} className="step-item">
              <span className="step-number" aria-hidden="true">{step.number}</span>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HowToUse;
